import { useState, useEffect } from 'react'
import useCallApi from '../../../utilities/axios'
import * as umServinceURL from '../umServiceURL'

const useAcademicPosition = () => {
    const callApi = useCallApi()
    const [state, setState] = useState([])

    useEffect(() => {
        getLookup()
    }, [])

    const getLookup = async () => {
        try {
            const { data } = await callApi.axiosGet<any>({
                url: umServinceURL.getLookupAcademicPosition
            })
            setState(data.result)
        } catch (error) {
            console.log('error', error)
        }
    }

    return { state }
}

export default useAcademicPosition
